export const GET_REDIRECT_URL = (apiUrl) => ({
  development: `${apiUrl}/accounts/login/?next=/reportingtool/redirect`,
  staging: `${apiUrl}/accounts/login/?next=/reportingtool/redirect-staging`,
  production: `${apiUrl}/accounts/login/?next=/reportingtool/redirect`,
});
